<template>
    <BasePanel :alvqa="alvqa" headline="lang_AZ_LIVE_CAPTION_VENUE_ROOMS">
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="item"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
            >
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>
                
                <template v-slot:[`item.name`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.type + '-text-name'">
                        {{ item.name }}
                    </div>
                </template>
                <template v-slot:[`item.area`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa +'-list-row-' + item.type + '-text-area'"
                    >
                        {{ $n(item.area, 'number') }}
                    </div>
                </template>
                <template v-slot:[`item.capacity`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa +'-list-row-' + item.type + '-text-capacity'"
                    >
                        {{ $n(item.capacity, 'number') }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name: "AzLiveVenueRoomsReadOnlyPanel",
    components: {
        BasePanel
    },
    props: {
        id: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'az-live-list-row-' + this.id + '-read-only-panel-venue-rooms'
        }
    },
    computed: { 
        item() { return this.$store.getters.getAzLiveVenueRooms },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        headers() {
            return [
                {
                    text: this.$t("lang_AZ_LIVE_VENUE_ROOMS_CAPTION_NAME"), 
                    align: "left", 
                    value: "name",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-name'
                },
                {
                    text: this.$t("lang_AZ_LIVE_VENUE_ROOMS_CAPTION_AREA") + ' (qm²)', 
                    align: "right", 
                    value: "area",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-area'
                },
                {
                    text: this.$t("lang_AZ_LIVE_VENUE_ROOMS_CAPTION_CAPACITY"), 
                    align: "right", 
                    value: "capacity",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-capacity'
                }
            ]
        },
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>